import apiClient from './apiClient';

const feedbackService = {
  submitFeedback: async (subject, message) => {
    const response = await apiClient.post('/feedback', { subject, message });
    return response.data;
  }
};

export default feedbackService;
